/**
 * 案例模板常量
 * 用于在添加自定义模板弹窗中展示参考案例
 */

export const EXAMPLE_TEMPLATES = {
  ENTERPRISE_RESEARCH: {
    title: "XXX企业访谈框架",
    info: `XXX企业访谈框架
   1、公司概况与历史沿革
   2、商业模式与产品
   3、市场分析
   4、核心壁垒
   5、竞争对比
   6、客户订单进展
   7、未来发展战略
   8、财务与融资`
  },

  PRODUCT_EVALUATION: {
    title: "XXX行业调研框架",
    info: `一、行业基本盘与驱动力
   1.行业定义与边界
   2.发展历程与关键驱动
   3.当前格局形成原因
   二、当下现状
   1.行业共识与误区
   2.关键瓶颈
   3.主要玩家画像
   三、未来推演
   1.短期趋势
   2.关键拐点判断
   3.投资机会`
  },

  PROJECT_REVIEW: {
    title: "XXX市场需求分析框架",
    info: `一、市场全景分析
   1.市场界定与容量
   2.核心动因与瓶颈
   二、用户与需求洞察
   1.用户画像与核心痛点
   2.决策场景与流程
   三、竞争格局评估
   1.竞争者与替代方案
   2.竞争焦点与空白
   四、需求趋势研判
   1.需求验证与演变
   2.未来需求猜想
   五、战略结论与建议
   1.核心发现与匹配建议
   2.关键风险提示`
  }
} as const;

// 默认展示的案例模板（可以根据需要调整）
export const DEFAULT_EXAMPLE_TEMPLATE = EXAMPLE_TEMPLATES.ENTERPRISE_RESEARCH;

// 案例模板数组，便于切换
export const EXAMPLE_TEMPLATES_LIST = [
  EXAMPLE_TEMPLATES.ENTERPRISE_RESEARCH,
  EXAMPLE_TEMPLATES.PRODUCT_EVALUATION,
  EXAMPLE_TEMPLATES.PROJECT_REVIEW
] as const;

/**
 * 场景模板常量 - 用于场景模式的模板展示
 * 专门针对金融会议场景
 */
export const SCENARIO_TEMPLATES = {
  INVESTOR_MEETING: {
    id: 'scenario_investor',
    title: '投资人交流会',
    shortDesc: '业绩汇报 策略沟通',
    iconName: 'FaUserTie',
    info: `一、会议背景与目的
二、公司业绩汇报
   1. 财务数据回顾
   2. 业务指标进展
   3. 里程碑达成情况
三、经营策略与调整
   1. 市场策略更新
   2. 产品路线图
   3. 组织架构优化
四、投资人关注问题
   1. 核心问题记录
   2. 管理层回应
五、后续行动计划
   1. 下阶段目标
   2. 协同事项`
  },

  POST_INVESTMENT_MEETING: {
    id: 'scenario_post_investment',
    title: '投后管理会',
    shortDesc: '运营监控 风险预警',
    iconName: 'MdManageAccounts',
    info: `一、项目运营概况
   1. 整体进展总结
   2. 团队建设情况
二、财务数据分析
   1. 收入成本分析
   2. 现金流状况
   3. 预算执行情况
三、风险点识别
   1. 运营风险
   2. 财务风险
   3. 合规风险
四、管理建议
   1. 改进方向
   2. 资源支持需求
五、下期重点关注`
  },

  VC_BOARD_MEETING: {
    id: 'scenario_board',
    title: '风险投资董事会',
    shortDesc: '决策审批 战略指导',
    iconName: 'HiUserGroup',
    info: `一、上期决议执行情况
二、本期重大事项汇报
   1. 融资进展
   2. 重大合作
   3. 人事变动
三、董事会决策事项
   1. 待表决议案
   2. 表决结果记录
四、战略指导意见
   1. 董事建议
   2. 战略方向调整
五、待办事项分配
   1. 责任人
   2. 完成时间`
  },

  FUNDRAISING_ROADSHOW: {
    id: 'scenario_roadshow',
    title: '融资路演',
    shortDesc: '项目展示 融资计划',
    iconName: 'FaChartLine',
    info: `一、项目亮点与核心优势
   1. 技术优势
   2. 团队优势
   3. 资源优势
二、市场机会与竞争分析
   1. 市场规模与增长
   2. 竞争格局
   3. 差异化定位
三、商业模式与盈利预测
   1. 收入模式
   2. 成本结构
   3. 未来三年财务预测
四、融资计划与资金用途
   1. 融资金额与估值
   2. 资金使用计划
   3. 退出机制
五、团队介绍与发展规划
   1. 核心团队背景
   2. 发展里程碑
六、投资人问答记录`
  },

  FUND_RAISING: {
    id: 'scenario_fundraising',
    title: '基金募资',
    shortDesc: '募资方案 LP沟通',
    iconName: 'GiReceiveMoney',
    info: `一、基金策略与投资方向
   1. 投资领域定位
   2. 投资阶段偏好
   3. 单笔投资规模
二、历史业绩与案例
   1. 过往基金表现
   2. 成功退出案例
   3. 投资组合概览
三、团队能力与资源
   1. 管理团队介绍
   2. 投后服务能力
   3. 行业资源网络
四、募资方案与条款
   1. 目标募资规模
   2. 基金结构与期限
   3. 管理费与收益分配
五、LP问答与关注点
   1. LP核心疑问
   2. 风险控制机制
   3. 信息披露机制`
  }
} as const;

// 场景模板数组，便于遍历展示
export const SCENARIO_TEMPLATES_LIST = [
  SCENARIO_TEMPLATES.INVESTOR_MEETING,
  SCENARIO_TEMPLATES.POST_INVESTMENT_MEETING,
  SCENARIO_TEMPLATES.VC_BOARD_MEETING,
  SCENARIO_TEMPLATES.FUNDRAISING_ROADSHOW,
  SCENARIO_TEMPLATES.FUND_RAISING
] as const;

// 场景模板映射表，用于根据 id 快速查找
export const SCENARIO_TEMPLATES_MAP = {
  [SCENARIO_TEMPLATES.INVESTOR_MEETING.id]: SCENARIO_TEMPLATES.INVESTOR_MEETING,
  [SCENARIO_TEMPLATES.POST_INVESTMENT_MEETING.id]: SCENARIO_TEMPLATES.POST_INVESTMENT_MEETING,
  [SCENARIO_TEMPLATES.VC_BOARD_MEETING.id]: SCENARIO_TEMPLATES.VC_BOARD_MEETING,
  [SCENARIO_TEMPLATES.FUNDRAISING_ROADSHOW.id]: SCENARIO_TEMPLATES.FUNDRAISING_ROADSHOW,
  [SCENARIO_TEMPLATES.FUND_RAISING.id]: SCENARIO_TEMPLATES.FUND_RAISING
} as const;